
<template>
  <div>
    <v-row v-if="item.external_item_id" class="mt-2">
      <v-col>
        <div>Devolução de: </div>
        <div> <b>{{solution_map[item.solution]}} </b></div>
      </v-col>
      <v-col>
        <div>Pedido:</div>
        <div> <b>#{{item.external_order_id}} </b></div>
      </v-col>
      <v-col>
        <div>Item:</div>
        <div> <b>#{{item.external_item_id}} </b></div>
      </v-col>
      <v-col>
        <div>Valor:</div>
        <div> <b>{{Number(item.ammount).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}} </b></div>
      </v-col>
      <v-col>
        <div>Data:</div>
        <div> <b>{{$moment(item.created_at).format('DD/MM/YY, HH:mm')}} </b></div>
      </v-col>
      <v-col cols='12'>
        <v-textarea readonly :value="item.description" prepend-icon="mdi-chat" label="Motivo/Comentários"></v-textarea>
      </v-col>
    </v-row>
    <v-row v-if="item.item_id">
      <v-col>
        <div>Marca:</div>
        <div> <b>{{item.item.brand.name}} </b></div>
      </v-col>
      <v-col>
        <div>Produto:</div>
        <div> <b>{{item.item.product.name}} </b></div>
      </v-col>
      <v-col>
        <div>Quantidade:</div>
        <div> <b>{{Number(item.item.total_units).toFixed(2)}} </b></div>
      </v-col>
      <v-col>
        <div>Valor total:</div>
        <div> <b>{{Number(item.item.total_sell_price).toLocaleString('pt-br', {style:'currency', currency: 'BRL'})}} </b></div>
      </v-col>
    </v-row>
    <v-form ref="formDevolution" v-if="item.item_id">
      <v-text-field :value="item.item.json_attributes.devolution_data.devolution_units.toFixed(2)" prepend-icon="mdi-undo" label="Unidades devolvidas" readonly></v-text-field>
      <v-textarea readonly :value="item.item.json_attributes.devolution_data.description" prepend-icon="mdi-chat" label="Motivo/Comentários"></v-textarea>
    </v-form>
    <v-row v-if="item.item_id">
      <v-col>
        <div>Unidades com o cliente:</div>
        <div> <b>{{(item.item.total_units - item.item.json_attributes.devolution_data.devolution_units).toFixed(2)}} </b></div>
      </v-col>
      <v-col>
        <div>Valor unitário:</div>
        <div> <b>{{Number(item.item.sell_price).toLocaleString('pt-br', {style:'currency', currency: 'BRL'})}} </b></div>
      </v-col>
      <v-col>
        <div>Valor total a devolver:</div>
        <div> <b>{{item.item.json_attributes.devolution_data.devolution_total_value.toLocaleString('pt-br', {style:'currency', currency: 'BRL'})}} </b></div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import SolutionMap from '@/_backoffice/_registrations/mixins/solution_map.js'


export default {
  name: 'PayDevolutionDetail',
  //mixins: [ validations ],
  mixins: [SolutionMap],
  props: {
    item: {
      type: Object,
    },
  },
}
</script>